// External imports
import { SVGProps } from "react";

export default function LeftArrowIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 -960 960 960"
      color="#000"
      {...props}
    >
      <path
        fill="currentColor"
        d="m313-440 224 224-57 56-320-320 320-320 57 56-224 224h487v80H313Z"
      />
    </svg>
  );
}
